import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
  property as propertyPropType,
  user as userPropType,
  orderBookStatus as orderBookStatusPropType,
  propertyAccess as propertyAccessPropType,
} from 'scripts/constants/PropTypes';

import FinancialsPanel from 'scripts/components/shared/FinancialsPanel';
import InitialBrickPriceBox from 'scripts/components/property/trade/InitialBrickPriceBox';
import ViewsOrSelldown from 'src/components/propertyCards/propertyCardPreOrder/viewsOrSelldown/ViewsOrSelldown';

import {
  fetchOrderBookStatus,
  fetchPropertyAccess,
} from 'scripts/redux/actions/market';
import {
  orderBookStatusSelector,
  propertyAccessSelector,
} from 'scripts/redux/selectors/market';
import { settlementInfoValueToShow } from 'scripts/utilities/propertyHelper';
import { isUserLoggedIn } from 'scripts/utilities/userAccountHelper';
import { toggleModal as toggleLoginOrSignupModalAction } from 'src/store/loginOrSignupModalActions';
import { renderCode } from 'src/settings/properties';

const SettlementText = ({ property }) => (
  <div className="text-center" style={{ margin: '10px' }}>
    Settlement Date: {settlementInfoValueToShow(property, false)}
  </div>
);

const mapStateToProps = (state) => ({
  ...orderBookStatusSelector(state),
  ...propertyAccessSelector(state),
});

@connect(mapStateToProps, {
  fetchOrderBookStatus,
  fetchPropertyAccess,
  toggleLoginOrSignupModal: toggleLoginOrSignupModalAction,
})
export default class InvestPanelPreOrder extends Component {
  static propTypes = {
    user: userPropType.isRequired,
    property: propertyPropType.isRequired,
    orderBookStatus: orderBookStatusPropType.isRequired,
    propertyAccess: propertyAccessPropType.isRequired,
    fetchOrderBookStatus: PropTypes.func.isRequired,
    fetchPropertyAccess: PropTypes.func.isRequired,
    handleBuyButtonClick: PropTypes.func.isRequired,
    toggleLoginOrSignupModal: PropTypes.func.isRequired,
  };

  state = {
    orderbookEnabled: true,
    canAccessProperty: true,
    preorderError: null,
    preOrderButtonClickedWhileUserLoggedOut: false,
  };

  componentDidMount() {
    const {
      property,
      fetchOrderBookStatus,
      fetchPropertyAccess,
    } = this.props;
    fetchOrderBookStatus(property.propertyCode);
    fetchPropertyAccess(property.propertyCode);
  }

  componentDidUpdate() {
    const { orderBookStatus, propertyAccess } = this.props;
    const orderBookStatusUpdated = !_.isNil(orderBookStatus)
      ? orderBookStatus.enabled !== this.state.orderBookEnabled
      : false;
    if (orderBookStatusUpdated) {
      this._updateOrderBookEnabledValue();
    }
    const propertyAccessUpdated = !_.isNil(propertyAccess)
      ? propertyAccess.canAccess !== this.state.canAccessProperty
      : false;
    if (propertyAccessUpdated) {
      this._updateCanAccessPropertyValue();
    }
    this._performActionAfterLoginPopup();
  }

  render() {
    const { property } = this.props;

    const viewsOrSelldown = (
      <div className="invest-panel-pre-order__views-selldown-container">
        <ViewsOrSelldown property={property} />
      </div>
    );

    return (
      <div className="pre-order-panel">
        <div className="mobile visible-xs">
          <InitialBrickPriceBox property={property} shownInLargerText />
          <SettlementText property={property} />
          <div className="grey-line"></div>
          {viewsOrSelldown}
          <button
            className="button blue-button trade-button buy-button right-arrow-button"
            onClick={this._handlePreOrderButtonClick}
          >
            PRE-ORDER BRICKS
          </button>
          <div className="trade-error">
            <b>{this.state.preorderError || <div>&nbsp;</div>}</b>
          </div>
        </div>
        <FinancialsPanel
          className="panel-financials-blue-header panel-financials-invest panel-pre-order hidden-xs"
          title={`Pre-order ${renderCode(property.propertyCode)}`}
        >
          <InitialBrickPriceBox property={property} shownInLargerText />
          <SettlementText property={property} />
          <div className="grey-line"></div>
          {viewsOrSelldown}
          <button
            className="button blue-button trade-button buy-button right-arrow-button"
            onClick={this._handlePreOrderButtonClick}
          >
            PRE-ORDER BRICKS
          </button>
          <div className="trade-error">
            <b>{this.state.preorderError || <div>&nbsp;</div>}</b>
          </div>
        </FinancialsPanel>
      </div>
    );
  }

  _updateOrderBookEnabledValue = () => {
    this.setState({ orderBookEnabled: this.props.orderBookStatus.enabled });
  };

  _updateCanAccessPropertyValue = () => {
    this.setState({ canAccessProperty: this.props.propertyAccess.canAccess });
  };

  _handlePreOrderButtonClick = () => {
    const { user, property, handleBuyButtonClick, toggleLoginOrSignupModal } = this.props;
    if (isUserLoggedIn(user)) {
      if (!this.state.orderBookEnabled) {
        this.setState({ preorderError: `The Order Book for ${renderCode(property.propertyCode)} is currently closed` });
      } else if (!this.state.canAccessProperty) {
        this.setState({ preorderError: `You do not have access to the property ${renderCode(property.propertyCode)}` });
      } else if (property.investmentMetrics.remainingBricks <= 0) {
        this.setState({ preorderError: `Sorry, all Bricks reserved. Check back later.` });
      } else {
        handleBuyButtonClick();
      }
    } else {
      this.setState({ preOrderButtonClickedWhileUserLoggedOut: true });
      toggleLoginOrSignupModal();
    }
  };

  _performActionAfterLoginPopup = async () => {
    const { user, property, fetchPropertyAccess } = this.props;
    const { preOrderButtonClickedWhileUserLoggedOut } = this.state;
    const isUserLoggedIn = !_.isNil(user.id);

    if (isUserLoggedIn && preOrderButtonClickedWhileUserLoggedOut) {
      await fetchPropertyAccess(property.propertyCode);
      this._handlePreOrderButtonClick();
      this.setState({ preOrderButtonClickedWhileUserLoggedOut: false });
    }
  };
}
